import { Box, Loader, Text, Title } from '@mantine/core'
import { useGetLastMeasurement } from 'api/measurements/getLastMeasurement'
import { useDayjs } from 'hooks/useDayjs'
import { useTranslation } from 'react-i18next'
import { useSearchParams } from 'react-router-dom'
import { TIndicator, TMeasurementItem } from 'shared/types'

type NumericalValueProps = {
  indicator: TIndicator['code']
  deviceId: string
  measurement?: TMeasurementItem
  fetchLatestMeasurement?: boolean
}

export const NumericalValue = ({
  indicator,
  deviceId,
  measurement,
  fetchLatestMeasurement = true,
}: NumericalValueProps) => {
  const { t } = useTranslation()
  const [urlParams] = useSearchParams()
  const params = Object.fromEntries(urlParams.entries())
  const dayjs = useDayjs()
  const { data, isSuccess, isLoading } = useGetLastMeasurement(
    deviceId,
    indicator,
    params?.toDate,
    !measurement && fetchLatestMeasurement,
  )
  const currentMeasurement = measurement ?? data
  const isFetchingLatestMeasurement = !measurement && fetchLatestMeasurement

  if (isLoading && isFetchingLatestMeasurement)
    return (
      <div
        style={{
          height: '350px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          textAlign: 'center',
        }}
      >
        <Loader variant="bars" color="orange" />
      </div>
    )

  if ((isSuccess || measurement) && currentMeasurement?.value != null) {
    const isOlderThanSixHours =
      dayjs().diff(dayjs(currentMeasurement.date), 'hours') > 6

    return (
      <div
        style={{
          height: '350px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          textAlign: 'center',
        }}
      >
        <div>
          <Title order={2} c={isOlderThanSixHours ? 'orange' : undefined}>
            {currentMeasurement.value.toFixed(2)}{' '}
            {currentMeasurement.unit?.symbol}
          </Title>
          <Box>
            <Text c="dimmed">
              {isOlderThanSixHours && t('measurement.isOld')}
            </Text>
            <Text c="dimmed">
              {t('generic.date')}:{' '}
              {dayjs(currentMeasurement.date).format('DD MMM YYYY, HH:mm')}
            </Text>
          </Box>
        </div>
      </div>
    )
  }
  return null
}
